import { Sparkles } from "lucide-react";
import { FX_TYPES } from "@/lib/captionFx";

// Pick / tune a moving look effect (also used to redesign the built-in Cinematic Looks).
export const CaptionFxControl = ({ fx, onChange, testid = "caption-fx" }) => {
  const f = fx || { type: "none" };
  const set = (patch) => {
    const next = { intensity: 0.7, ...f, ...patch };
    onChange(next.type === "none" ? null : next);
  };
  return (
    <div className="flex w-full flex-wrap items-center gap-2 rounded-lg border border-white/10 bg-white/[0.02] p-2.5" data-testid={testid}>
      <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#A1A1AA]"><Sparkles size={11} className="text-[#FFC94D]" /> Look effect</span>
      <select value={f.type || "none"} onChange={(e) => set({ type: e.target.value })} data-testid={`${testid}-type`}
        className="min-w-0 flex-1 rounded border border-white/10 bg-white/[0.03] px-2 py-1 text-xs text-white outline-none">
        {FX_TYPES.map(([v, l]) => <option key={v} value={v} className="bg-[#141414]">{l}</option>)}
      </select>
      {f.type && f.type !== "none" && (<>
        <label className="flex items-center gap-1 text-xs text-[#A1A1AA]">Strength
          <input type="range" min="0" max="1" step="0.05" value={f.intensity ?? 0.7} data-testid={`${testid}-intensity`}
            onChange={(e) => set({ intensity: +e.target.value })} className="w-20 accent-[#FFC94D]" /></label>
        <label className="flex items-center gap-1 text-xs text-[#A1A1AA]">Colour
          <input type="color" value={f.color || "#FFC94D"} data-testid={`${testid}-color`} onChange={(e) => set({ color: e.target.value })}
            className="h-6 w-8 cursor-pointer rounded border border-white/15 bg-transparent" /></label>
      </>)}
    </div>
  );
};
